export interface PresetIds {
  prod: string
  staging: string
  dev: string
}
const env = import.meta.env.REACT_APP_ENV! as 'prod' | 'staging' | 'dev'

const clientAndAdvisorFollowUpsIds: PresetIds = { prod: 'cqkkd1xbz240b6b7', staging: '9xbrgp80b4ls6qbx', dev: '9xbrgp80b4ls6qbx' }
const meetingPurposeIds: PresetIds = { dev: '6c5b67xk6eca2pqw', staging: '3h5ru2ul1ibei8nr', prod: 'cinohoyphbq9k6ze' }
const futureMeetingsIds: PresetIds = { dev: '0wjli2zuhql13b8c', staging: '70952walunyoh784', prod: 'cvlbyfpvcpn8lm79' }

export const TASK_PRESET_IDS = [clientAndAdvisorFollowUpsIds[env]]
export const NOTE_PRESET_IDS = [meetingPurposeIds[env]]
export const EVENT_PRESET_IDS = [futureMeetingsIds[env]]
